import Visitors from '../VisitorsComponent.vue'

export default [
    {
        path: '/visitors',
        name: '/visitors',
        component: Visitors,
        meta: {
            layout: 'admin-layout'
        }
    }
]